import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { HttpStatusCode } from "axios";
import { rejectAxiosError } from "../rtkErrorNotifications";

const baseUrl = () =>
  process.env.REACT_APP_USE_LOCAL_API_URL === "true"
    ? process.env.REACT_APP_LOCAL_API_URL
    : process.env.REACT_APP_EXTERNAL_API_URL;

const authConfig = () => ({
  headers: {
    Authorization: localStorage.getItem("token"),
  },
});

const expectOk = (response) => {
  if (response.status === HttpStatusCode.Ok) {
    return response.data;
  }
  throw new Error();
};

export const fetchEmailTemplate = createAsyncThunk(
  "emailTemplates/fetch",
  async ({ key }, api) => {
    try {
      const response = await axios.get(
        `${baseUrl()}/email_templates/${key}`,
        authConfig(),
      );
      return expectOk(response);
    } catch (error) {
      return rejectAxiosError(error, api);
    }
  },
);

export const updateEmailTemplate = createAsyncThunk(
  "emailTemplates/update",
  async ({ key, subject, body }, api) => {
    try {
      const response = await axios.patch(
        `${baseUrl()}/email_templates/${key}`,
        { subject, body },
        authConfig(),
      );
      return expectOk(response);
    } catch (error) {
      return rejectAxiosError(error, api);
    }
  },
);

// Renders an unsaved draft with sample data; resolves to { subject, html }
export const previewEmailTemplate = createAsyncThunk(
  "emailTemplates/preview",
  async ({ key, subject, body }, api) => {
    try {
      const response = await axios.post(
        `${baseUrl()}/email_templates/${key}/preview`,
        { subject, body },
        authConfig(),
      );
      return expectOk(response);
    } catch (error) {
      return rejectAxiosError(error, api);
    }
  },
);

export const resetEmailTemplate = createAsyncThunk(
  "emailTemplates/reset",
  async ({ key }, api) => {
    try {
      const response = await axios.post(
        `${baseUrl()}/email_templates/${key}/reset`,
        {},
        authConfig(),
      );
      return expectOk(response);
    } catch (error) {
      return rejectAxiosError(error, api);
    }
  },
);
